

































import VueOptions from '@utils/VueOptions'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'ResourceBindSelector'

  vue:
    props: ['disabledBind', 'options']

    components: {
      DropdownFilter,
    }

    methods:
      close: ->
        @$refs.bindItems.hiCloseModal()

    watch:
      disabledBind: (disabled) ->
        @close() if disabled

export default VueOptions.vue settings
